// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2g0er","requiredAsterisk":"Info_requiredAsterisk__E4zGy"};